import { Logger } from '@turnaroundfactor/common';

const logger = new Logger({
  log_source: "@adapt/webui",
  source: '@adapt/webui',
  endpoint: window.navigator.userAgent
});

logger.level = 'info';
export default logger;